export default {
  name: 'responsive-image',
  props: {
    src: {
      type: Object,
      required: true
    },
    maxSize: Number,
    background: Boolean,
    preload: {
      type: Boolean,
      default: false
    }
  },
  render (createElement) {
    if (!this.src) {
      return createElement('span', {
        'class': 'px3 py2 bg-white rounded border border-silver'
      }, 'No image :(')
    }
    let srcset = [
      `${this.src.sizes.thumbnail} 300w`,
      `${this.src.sizes.medium} 620w`,
      `${this.src.sizes.medium_large} 768w`,
      `${this.src.sizes.large} 1600w`,
      `${this.src.url} 2400w`
    ]
    if (this.maxSize) {
      srcset = srcset.slice(0, this.maxSize)
    }
    let classList = this.preload ? 'lazyload visible' : 'lazyload'
    if (this.background) {
      return createElement('div', {
        'class': [classList, 'bg-contain bg-no-repeat bg-center'],
        ref: 'picture',
        attrs: {
          'data-bgset': srcset.join(', ')
        }
      })
    }
    return createElement('img', {
      'class': classList,
      ref: 'picture',
      attrs: {
        // src: this.src.url
        'data-srcset': srcset.join(', '),
        sizes: '1600px',
        width: this.src.width,
        height: this.src.height
      }
    })
  },
  watch: {
    src (newVal) {
      if (newVal) {
        const classes = this.$refs.picture.classList
        classes.toggle('lazyloaded')
        classes.toggle('lazyload')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/ResponsiveImage.js